import clsx from 'clsx';
import { ReactNode } from 'react';
import styles from './AboutUsSiteContainer.module.css';

interface Props {
  wider?: boolean;
  withVerticalGaps?: boolean;
  overlapAbove?: boolean;
  overlapBelow?: boolean;
  positionRelative?: boolean;
  /** Whether this container's children should appear in two equal columns on
   * desktop devices, and whether they should be swapped
   */
  twoColumn?: boolean | 'reverse';
  styles2026?: boolean;
  children: ReactNode;
}

const AboutUsSiteContainer = (props: Props) => (
  <div
    className={clsx(
      styles.siteContainer,
      props.styles2026 ? styles.styles2026 : '',
      props.wider ? styles.wider : '',
      props.withVerticalGaps ? styles.withVerticalGaps : '',
      props.positionRelative ? styles.positionRelative : '',
      props.overlapAbove ? styles.overlapAbove : '',
      props.overlapBelow ? styles.overlapBelow : '',
      props.twoColumn ? styles.twoColumn : '',
      props.twoColumn === 'reverse' ? styles.twoColumnSwapOnDesktop : '',
    )}
  >
    {props.children}
  </div>
);

export default AboutUsSiteContainer;
